// extracted by mini-css-extract-plugin
export default {"column":"work-order-device-groups-detail-layout-columns_column__fTWs+"};